import { createContext } from "react";

export const ActiveCategoryContext = createContext<null | {
  activeCategory: string | null;
  setActive: (arg0: string) => void;
  activeSearch: string | null;
  shortName: string | null;
  setShortName: (arg0: string) => void;
}>(null);
